import { cleanApiMessages } from './apiMessages';
import { IBodyItemResponse, apiManager } from '../REST';
import { IPatchItem, IRequestAPIBody, IZoneInfo } from '../interfaces';
import { IMapField, mapApi2UiField, mapUi2ApiField } from '../instruments';

export async function getZoneById(id: string): Promise<IZoneInfo | undefined> {
    cleanApiMessages();
    const { resp, isError } = await apiManager.getApi('GET_ZONE', { id });
    const { data } = resp as IBodyItemResponse;

    if (isError || !data?.id) {
        return;
    }

    return {
        id: data.id,
        ...mapApi2UiField(data.attributes || {}),
    };
}

export async function patchZone(id: string, fields: IMapField): Promise<IPatchItem> {
    const body: IRequestAPIBody = {
        data: {
            id,
            type: 'zone',
            attributes: mapUi2ApiField(fields),
        },
    };
    const { resp, isError } = await apiManager.getApi(id ? 'PATCH_ZONE' : 'POST_ZONE', { id }, body);
    const { errors } = resp as IBodyItemResponse;

    return { isError, errors };
}
